import styled from 'styled-components'

import { BaseLayoutContent, BaseLayoutContentProps } from '../BaseLayoutContent'

export const ContentStyled = styled(BaseLayoutContent)<BaseLayoutContentProps>`
  padding: 24px 16px;
`
